import { Component } from '@angular/core';

@Component({
  selector: 'app-collection-statements',
  templateUrl: './collection-statements.component.html',
  styleUrls: ['./collection-statements.component.scss']
})
export class CollectionStatementsComponent {}
